import React, { useState } from "react";
import Table from "../../../Table";
import Modal from "../../../modal";
import NoData from "../../../noData";

const PaymnetTable = ({
  loading,
  getPaymentData,
  closePaymentDeleteModal,
  openPaymentDeleteModal,
  isPaymentDeleteOpen,
  setIsPaymentDeleteOpen,
  handleDeletePayment,
  lastElementRef,
  openEditModal,
}) => {
  const tableHeading = {
    no: <div className="ml-2 text-center">No.</div>,
    paymentMethod: <div className="text-center px-2">Payment Method</div>,
    balance: <div className="text-center">Balance</div>,
    store: <div className="px-2 text-left">Store</div>,
    editDetail: <div className="mr-2 text-center"></div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = getPaymentData?.map((e, index) => {
    return {
      no: <div className="ml-2 text-center">{index + 1}</div>,
      paymentMethod: <div className="text-center px-2">{e?.paymentmethod}</div>,
      balance: <div className="text-center">{e?.Balance}</div>,

      store: (
        <div className="px-2 text-left">
          {e?.stores.map((data) => data?.store?.name).join(", ")}
        </div>
      ),
      editDetail: (
        <div className="mr-2  flex justify-center gap-5">
          <img
            onClick={() => openEditModal(e)}
            className="cursor-pointer"
            src="/images/pencilIcon.svg"
            alt=""
          />
          <img
            onClick={() => openPaymentDeleteModal(e)}
            className="cursor-pointer"
            src="/images/deleteIcon.svg"
            alt=""
          />
        </div>
      ),
    };
  });

  return (
    <>
      {getPaymentData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        loading={loading}
        modalWidth="w-1/3"
        isOpen={isPaymentDeleteOpen}
        setIsOpen={setIsPaymentDeleteOpen}
        openModal={openPaymentDeleteModal}
        closeModal={closePaymentDeleteModal}
        handleBtn2={handleDeletePayment}
        imgSrc="/images/exclamationIcon.svg"
        title="Are You Sure?"
        btn1="Cancel"
        btn2="Delete"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Deleting will permanently remove this Detail the system.
          </p>
        }
      />
    </>
  );
};

export default PaymnetTable;
